export const API_URL = "https://auditoria.emalytics.pt/api";

// ===============================
// Token helpers
// ===============================
function getToken() {
  return localStorage.getItem("token");
}

function getRefreshToken() {
  return localStorage.getItem("refresh_token");
}

// ===============================
// Refresh token
// ===============================
async function refreshToken() {
  const refresh = getRefreshToken();
  if (!refresh) throw new Error("NO_REFRESH_TOKEN");

  const res = await fetch(API_URL + "/auth/refresh", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ refresh_token: refresh }),
  });

  if (!res.ok) {
    throw new Error("REFRESH_FAILED");
  }

  const data = await res.json();

  localStorage.setItem("token", data.access_token);
  localStorage.setItem("refresh_token", data.refresh_token);

  return data.access_token;
}

// ===============================
// Core fetch with auto-refresh
// ===============================
async function fetchWithAuth(url, options = {}) {
  let token = getToken();

  let res = await fetch(API_URL + url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  });

  // 🔁 Access token expirou → tentar refresh
  if (res.status === 401) {
    try {
      token = await refreshToken();

      res = await fetch(API_URL + url, {
        ...options,
        headers: {
          ...(options.headers || {}),
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (err) {
      // ❌ refresh falhou → logout forçado
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      window.location.href = "/login";
      throw err;
    }
  }

  return res;
}

// ===============================
// API helpers
// ===============================
export async function apiGet(url) {
  const res = await fetchWithAuth(url);

  if (!res.ok) {
    const text = await res.text();
    throw new Error("GET error: " + text);
  }

  return res.json();
}

export async function apiPost(url, data) {
  const res = await fetchWithAuth(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error("POST error: " + text);
  }

  return res.json();
}

export async function apiPostFile(url, formData) {
  const res = await fetchWithAuth(url, {
    method: "POST",
    body: formData,
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error("POST FILE error: " + text);
  }

  return res.json();
}

export async function apiDelete(url) {
  const res = await fetchWithAuth(url, {
    method: "DELETE",
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error("DELETE error: " + text);
  }

  return res.json();
}
